<template>
  <div
    class="card clickable"
    @click="$router.push({ path: `/dds/${employee.id}` })"
  >
    <div class="card-head">{{ employee.name }}</div>
    <div :class="'card-param-list row-' + perRow">
      <div
        class="card-param"
        v-for="(employee, index) in childrenEmployee"
        :key="index"
      >
        <div class="card-param-name dds-position">
          {{ employee.name }}
        </div>
        <div class="card-param-name dds-fio">
          {{ employee.value }}
        </div>
        <div class="card-param-name">
          {{ employee.phone }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EmployeeApi } from "../api/EmployeeApi";
import Employee from "../models/Employee";

export default {
  name: "DDSCard",
  props: {
    perRow: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      uuid: this.$attrs.It.id,
      employee: new Employee(this.$attrs.It),
      childrenEmployee: [],
    };
  },
  created() {
    this.loadEmployee();
  },
  methods: {
    async loadEmployee() {
      const data = await EmployeeApi.getList({
        parentId: this.employee.id,
        page: 0,
        size: 20,
      });
      this.childrenEmployee = data.content.map((el) => {
        return new Employee(el);
      });
    },
  },
};
</script>

<style scoped>
</style>
